<template>
  <SelectComponent
    v-model="localModelValue"
    :values="normalizedCategories"
    :label="label"
    :required="required"
    :name="name"
    :errors="errors"
    :edition-mode="editionMode"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'

export default {
  name: 'SelectCategoryDevisNormalised',
  components: { SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    oldList: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters('metadata', {
      normalizedCategoriesOld: 'getMetadataCategoriesNormalized',
      normalizedCategoriesNew: 'getMetadataCategoriesNormalizedNewList',
    }),
    localModelValue: {
      get() {
        return this.oldList ?
          (typeof this.modelValue === 'string'
            ? parseInt(this.modelValue)
            : this.modelValue)
          : this.modelValue
      },
      set(value) {
        console.log(value)
        this.$emit('update:modelValue', value)
      }
    },
    normalizedCategories() {
      if(this.oldList) return this.normalizedCategoriesOld
      return this.normalizedCategoriesNew
    },
    label() {
      if(this.oldList) return this.$t('global.category_devis_normalised')
      return this.$t('global.category_devis_normalised_2025')
    },
    name() {
      if(this.oldList) return 'category_devis_normalised'
      return 'category_devis_normalised_2025'
    }
  }
}
</script>
